import { useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';
import { ROUTES } from '@/config/routes';

interface NewOrderSplitButtonProps {
  onOpenDrawer: () => void;
}

export function NewOrderSplitButton({ onOpenDrawer }: NewOrderSplitButtonProps) {
  const navigate = useNavigate();

  return (
    <div className="inline-flex">
      {/* max-lg:px-4 trims the button's footprint on a phone, where it shares
          the title row. Only the padding gives — the height stays at the
          Button primitive's max-lg:h-11, which is the 44px touch floor the
          viewport suite asserts. */}
      <Button
        type="button"
        onClick={onOpenDrawer}
        className="rounded-r-none px-6 max-lg:px-4"
      >
        New Order
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            type="button"
            aria-label="More Order Options"
            className="rounded-l-none border-l border-l-primary-foreground/20 px-2 max-lg:min-w-11"
          >
            <ChevronDown className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={onOpenDrawer}>
            Place Individual Order
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => navigate(ROUTES.ORDERS_NEW_IMPORT)}>
            Place Bulk Order
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
